import React from "react";
import PublicPageLayout from "../components/PublicPageLayout";

export default function Terms() {
  return (
    <PublicPageLayout eyebrow="Legal" title="Terms of Service" subtitle="Last updated: July 2026">
      <p>
        These Terms of Service ("Terms") govern your use of Adyap. By creating an account or using the product, you
        agree to these Terms. If you don't agree, please don't use Adyap.
      </p>

      <h2>Using Adyap</h2>
      <p>
        You must be at least 16 years old to create an account. You're responsible for the accuracy of the
        information you provide, including your resume and career goals, and for keeping your login credentials
        secure. You're responsible for all activity under your account.
      </p>

      <h2>Acceptable use</h2>
      <ul>
        <li>Don't misrepresent your identity, credentials, or progress to game your readiness score.</li>
        <li>Don't upload content you don't have the right to share, or that infringes someone else's rights.</li>
        <li>Don't attempt to disrupt, reverse-engineer, or abuse Adyap's systems, including its AI features.</li>
        <li>Don't use Adyap for any unlawful purpose.</li>
      </ul>

      <h2>AI-generated content</h2>
      <p>
        Roadmaps, skill-gap analyses, interview feedback, and readiness scores are generated with the help of AI
        models and are provided for guidance only. They may be incomplete or inaccurate, and they aren't a
        guarantee of employment, salary, or interview outcomes. You remain responsible for your own career
        decisions.
      </p>

      <h2>Your content</h2>
      <p>
        You retain ownership of the resume, goals, and other content you provide. You grant us a limited license to
        use that content to operate and improve Adyap, including processing it through our AI providers as
        described in our <a href="/privacy">Privacy Policy</a>.
      </p>

      <h2>Intellectual property</h2>
      <p>
        Adyap's product, branding, and underlying technology are owned by us or our licensors. These Terms don't
        grant you any rights to our trademarks or intellectual property beyond what's needed to use the product.
      </p>

      <h2>Termination</h2>
      <p>
        You may stop using Adyap and delete your account at any time. We may suspend or terminate accounts that
        violate these Terms or that we reasonably believe pose a risk to the platform or other users.
      </p>

      <h2>Disclaimers and limitation of liability</h2>
      <p>
        Adyap is provided "as is" without warranties of any kind. To the fullest extent permitted by law, Adyap and
        its team aren't liable for indirect, incidental, or consequential damages arising from your use of the
        product.
      </p>

      <h2>Changes to these Terms</h2>
      <p>
        We may update these Terms as Adyap evolves. Material changes will be communicated in the app or by email
        before they take effect. Continuing to use Adyap after changes take effect means you accept the updated
        Terms.
      </p>

      <h2>Contact us</h2>
      <p>
        Questions about these Terms? Email us at <a href="mailto:hello@adyap.in">hello@adyap.in</a>.
      </p>
    </PublicPageLayout>
  );
}
